import type { FC } from 'react';
import { Inline } from '@george-labs.com/design-system';

import type { DateFormat } from '@luna/date';
import { formatDate } from '@luna/date';

import type { CommonItemProps } from './types';
import { ProductsListItemWrapper } from '../ProductsListItemWrapper';

type Props = CommonItemProps & {
    startDate: string;
    startDateFormat?: DateFormat;
    endDate: string;
    endDateFormat?: DateFormat;
    bold?: boolean;
};

export const ProductsListDateRangeItem: FC<Props> = ({
    'data-cy': dataCy,
    className,
    label,
    labelClassName,
    labelColumnWidth,
    startDate,
    startDateFormat,
    endDate,
    endDateFormat,
    bold = false,
}) => {
    const displayedStartDate = startDateFormat
        ? formatDate(startDate, startDateFormat)
        : formatDate(startDate);

    const displayedEndDate = endDateFormat
        ? formatDate(endDate, endDateFormat)
        : formatDate(endDate);

    return (
        <ProductsListItemWrapper
            data-cy={dataCy}
            className={className}
            label={label}
            labelClassName={labelClassName}
            labelColumnWidth={labelColumnWidth}
        >
            <Inline data-cy={dataCy} emphasis={bold}>
                {displayedStartDate} - {displayedEndDate}
            </Inline>
        </ProductsListItemWrapper>
    );
};
